export const pt = {
  // Brand
  'brand.name': 'PAPO',
  'brand.full': 'Poder Angolano Para Organizados',
  'brand.subtitle': 'Poder Angolano',
  'brand.suffix': 'Para Organizados',
  'brand.copyright': '© 2026 PAPO: Poder Angolano Para Organizados. Angola livre, Angola nossa.',
  // Landing Slogans
  'landing.slogan.0': 'Onde a nossa voz nao se cala \u2013 Angola livre, Angola nossa.',
  'landing.slogan.1': 'Sem medo, sem mordaca \u2013 por uma Angola de direitos e justica.',
  'landing.slogan.2': 'Unidos contra o regime que nos oprime \u2013 a liberdade nao e crime.',
  'landing.slogan.3': 'Do nepotismo a esperanca: juntos por uma Angola soberana.',
  'landing.slogan.4': 'Fala, Angola! Aqui o povo denuncia, resiste e constroi o futuro.',
  'landing.slogan.5': 'Cria a tua Angola. Sem medo, sem censura, so talento e historias novas.',
  // Landing buttons
  'landing.login': 'Entrar',
  'landing.register': 'Junta-te',
  'landing.join': 'Junta-te a resistencia',
  'landing.haveAccount': 'Ja tenho conta',
  'landing.createAccount': 'Criar a minha conta',
  // Landing features
  'landing.feat.safe.title': 'Espaco Seguro',
  'landing.feat.safe.desc': 'Protegido contra censura e vigilancia. A tua voz, a tua liberdade.',
  'landing.feat.community.title': 'Comunidade Unida',
  'landing.feat.community.desc': 'Conecta com angolanos organizados que lutam por soberania e justica.',
  'landing.feat.resist.title': 'Denuncia e Resiste',
  'landing.feat.resist.desc': 'Reporta abusos, partilha testemunhos, constroi o futuro de Angola.',
  'landing.feat.privacy.title': 'Privacidade Total',
  'landing.feat.privacy.desc': 'Os teus dados nunca serao vendidos. Cumprimos com a lei internacional.',
  'landing.different': 'Uma rede social',
  'landing.different2': 'diferente',
  'landing.differentDesc': 'Criada por e para angolanos que querem viver livres da orbita do regime.',
  'landing.heroCaption': 'Fala, Angola! Aqui o povo denuncia, resiste e constroi o futuro.',
  // Landing values
  'landing.values': 'Os Nossos Valores',
  'landing.valuesTitle': 'Construindo uma Angola',
  'landing.valuesDemocratic': 'soberana',
  'landing.power.title': 'Poder ao Povo',
  'landing.power.desc': 'Cada voz conta. Cada denuncia importa. Juntos somos mais fortes.',
  'landing.transparency.title': 'Transparencia',
  'landing.transparency.desc': 'Sem algoritmos manipuladores. Sem dados vendidos. Sem censura.',
  'landing.unity.title': 'Unidade Angolana',
  'landing.unity.desc': 'Um espaco inclusivo para todos os angolanos que sonham com a liberdade.',
  'landing.cta.title': 'A liberdade nao e crime',
  'landing.cta.desc': 'Unidos contra o regime que nos oprime. Junta-te ao PAPO e faz parte da mudanca.',
  // Nav
  'nav.home': 'Inicio',
  'nav.groups': 'Grupos',
  'nav.events': 'Eventos',
  'nav.messages': 'Mensagens',
  'nav.wallet': 'Carteira',
  'nav.analytics': 'Analiticas',
  'analytics.title': 'Analiticas',
  'analytics.subtitle': 'Estatisticas de interacao e tendencias',
  'analytics.reactions': 'Reacoes',
  'analytics.comments': 'Comentarios',
  'analytics.messages': 'Mensagens',
  'analytics.profileViews': 'Visitas ao perfil',
  'analytics.yourEngagement': 'Teu engagement',
  'analytics.othersEngagement': 'Engagement dos outros',
  'analytics.totalOutgoing': 'Interacoes que fizeste',
  'analytics.totalIncoming': 'Interacoes que recebeste',
  'analytics.topFriends': 'Amigos mais interativos',
  'analytics.noData': 'Sem dados de interacao ainda',
  'analytics.activityChart': 'Atividade dos ultimos 30 dias',
  'analytics.noActivity': 'Sem atividade neste periodo',
  'analytics.posts': 'Posts',
  'nav.profile': 'Meu perfil',
  'nav.settings': 'Configuracoes',
  'nav.logout': 'Terminar sessao',
  // Auth
  'auth.email': 'Email',
  'auth.password': 'Palavra-passe',
  'auth.confirmPassword': 'Confirmar palavra-passe',
  'auth.name': 'Nome completo',
  'auth.login': 'Entrar',
  'auth.register': 'Criar conta',
  'auth.logging': 'A entrar...',
  'auth.registering': 'A criar conta...',
  'auth.loginTitle': 'Entrar na tua conta',
  'auth.registerTitle': 'Criar a tua conta',
  'auth.loginSubtitle': 'A tua voz importa. Angola precisa de ti.',
  'auth.registerSubtitle': 'Junta-te a comunidade que esta a mudar Angola.',
  'auth.noAccount': 'Nao tens conta?',
  'auth.haveAccount': 'Ja tens conta?',
  'auth.registerLink': 'Cria uma agora',
  'auth.loginLink': 'Entra aqui',
  'auth.googleLogin': 'Continuar com Google',
  'auth.backHome': 'Voltar ao inicio',
  'auth.fillAll': 'Por favor preenche todos os campos',
  'auth.passNoMatch': 'As palavras-passe nao coincidem',
  'auth.passMin': 'A palavra-passe deve ter pelo menos 6 caracteres',
  'auth.welcomeBack': 'Bem-vindo de volta!',
  'auth.welcome': 'Bem-vindo ao PAPO!',
  'auth.loginError': 'Erro ao iniciar sessao',
  'auth.sessionExpired': 'A sua sessão expirou. Faça login novamente.',
  'auth.registerError': 'Erro ao criar a conta',
  // Dashboard
  'dash.createPost': 'O que queres partilhar?',
  'dash.share': 'Partilhar',
  'dash.myGroups': 'Os meus grupos',
  'dash.seeAllGroups': 'Ver todos',
  'dash.upcomingEvents': 'Proximos eventos',
  'dash.seeAllEvents': 'Ver todos',
  'dash.members': 'membros',
  'dash.loadError': 'Erro ao carregar o feed',
  'dash.releaseToRefresh': 'Solte para atualizar',
  // Groups
  'groups.title': 'Grupos',
  'groups.search': 'Procurar grupos...',
  'groups.create': 'Criar grupo',
  'groups.new': 'Novo grupo',
  'groups.name': 'Nome do grupo',
  'groups.description': 'Descricao',
  'groups.category': 'Categoria',
  'groups.creating': 'A criar...',
  'groups.join': 'Juntar',
  'groups.leave': 'Sair',
  'groups.joined': 'Membro',
  'groups.noGroups': 'Nenhum grupo encontrado',
  'groups.loadError': 'Erro ao carregar os grupos',
  'groups.createError': 'Erro ao criar o grupo',
  'groups.created': 'Grupo criado!',
  'groups.fillAll': 'Preenche todos os campos',
  'groups.joinedMsg': 'Te has unido al grupo',
  'groups.leftMsg': 'Has salido del grupo',
  'groups.cat.all': 'Todos',
  'groups.cat.general': 'Geral',
  'groups.cat.wellness': 'Bem-estar',
  'groups.cat.mindfulness': 'Consciencia',
  'groups.cat.creativity': 'Criatividade',
  'groups.cat.support': 'Apoio',
  'groups.cat.learning': 'Aprendizagem',
  // Events
  'events.title': 'Eventos',
  'events.create': 'Criar evento',
  'events.new': 'Novo evento',
  'events.eventTitle': 'Titulo',
  'events.description': 'Descricao',
  'events.date': 'Data',
  'events.location': 'Localizacao',
  'events.creating': 'A criar...',
  'events.attend': 'Participar',
  'events.attending': 'Inscrito',
  'events.attendees': 'participantes',
  'events.noEvents': 'Nenhum evento encontrado',
  'events.loadError': 'Erro ao carregar os eventos',
  'events.createError': 'Erro ao criar o evento',
  'events.created': 'Evento criado!',
  'events.fillAll': 'Preenche todos os campos obrigatorios',
  'events.attendOk': 'Inscricao confirmada!',
  'events.unattendOk': 'Ja nao vais participar',
  'events.attendError': 'Erro ao processar o pedido',
  // Messages
  'msg.title': 'Mensagens',
  'msg.search': 'Procurar utilizadores...',
  'msg.typeMessage': 'Escreve uma mensagem...',
  'msg.noConversations': 'Sem conversas ainda',
  'msg.startChat': 'Inicia uma conversa',
  'msg.selectChat': 'Seleciona uma conversa',
  'msg.sendError': 'Erro ao enviar a mensagem',
  'msg.report': 'Denunciar utilizador',
  'msg.block': 'Bloquear utilizador',
  // Search
  'search.title': 'Resultados da pesquisa',
  'search.placeholder': 'Procurar...',
  'search.for': 'Resultados para',
  'search.error': 'Erro ao procurar',
  'search.all': 'Tudo',
  'search.people': 'Pessoas',
  'search.posts': 'Publicacoes',
  'search.groups': 'Grupos',
  'search.hashtags': 'Hashtags',
  'search.searching': 'Procurando...',
  'search.results': 'resultados',
  'search.users': 'Utilizadores',
  'search.posts': 'Publicacoes',
  'search.groups': 'Grupos',
  'search.events': 'Eventos',
  'search.hashtags': 'Hashtags',
  // Wellness
  'wellness.title': 'O teu bem-estar',
  'wellness.session': 'Sessao',
  'wellness.dailyUsage': 'Uso diario',
  'wellness.nearLimit': 'Estas perto do teu limite diario. Considera fazer uma pausa.',
  'wellness.reminder': 'As redes sociais sao uma ferramenta, nao uma obrigacao.',
  'wellness.takeBreak': 'Fazer uma pausa',
  'wellness.breakTitle': 'Momento de pausa',
  'wellness.sessionTime': 'Tempo de sessao',
  'wellness.minutes': 'minutos',
  'wellness.inhale': 'Inspira',
  'wellness.hold': 'Segura',
  'wellness.exhale': 'Expira',
  'wellness.notNow': 'Agora nao',
  'wellness.break5': 'Descanso 5 min',
  'wellness.restMode': 'Modo Descanso',
  'wellness.endBreak': 'Terminar descanso',
  'wellness.weeklyTitle': 'Bem-estar Semanal',
  'wellness.weeklySubtitle': 'Os teus ultimos 7 dias',
  'wellness.totalWeek': 'Total semana',
  'wellness.avgDaily': 'Media diaria',
  'wellness.breaksTaken': 'Pausas feitas',
  'wellness.streak': 'Dias em serie',
  'wellness.currentSession': 'Sessao atual',
  // Posts
  'post.comment': 'Escrever um comentario...',
  'post.comments': 'comentarios',
  'post.loadComments': 'Ver comentarios',
  'post.deleteConfirm': 'Eliminar publicacao?',
  'post.report': 'Denunciar',
  'post.block': 'Bloquear',
  'post.moderation': 'Estado de moderacao',
  'post.tip': 'Gorjeta',
  'post.delete': 'Eliminar',
  // Wallet
  'wallet.title': 'Carteira',
  'wallet.balance': 'Saldo total',
  'wallet.send': 'Enviar',
  'wallet.receive': 'Receber',
  'wallet.swap': 'Trocar',
  'wallet.stake': 'Staking',
  'wallet.transactions': 'Transacoes',
  'wallet.noTransactions': 'Sem transacoes',
  // Donation
  'donation.title': 'Apoiar o PAPO',
  'donation.desc': 'A tua doacao ajuda a manter a plataforma viva e independente.',
  'donation.copy': 'Copiar',
  'donation.copied': 'Copiado!',
  // Settings
  'settings.title': 'Configuracoes',
  'settings.account': 'Conta',
  'settings.privacy': 'Privacidade',
  'settings.notifications': 'Notificacoes',
  'settings.wellness': 'Bem-estar',
  'settings.theme': 'Tema',
  'settings.language': 'Idioma',
  'settings.export': 'Exportar dados',
  'settings.delete': 'Eliminar conta',
  // Profile
  'profile.followers': 'Seguidores',
  'profile.following': 'A seguir',
  'profile.posts': 'Publicacoes',
  'profile.follow': 'Seguir',
  'profile.suggestions': 'Sugestões',
  'profile.noSuggestions': 'Sem sugestões por agora',
  'friends.addFriend': 'Adicionar amigo',
  'friends.friends': 'Amigos',
  'friends.pending': 'Pendente',
  'friends.accept': 'Aceitar',
  'friends.requestSent': 'Pedido enviado',
  'friends.accepted': 'Agora sao amigos!',
  'friends.removed': 'Amigo removido',
  'circles.title': "Círculos",
  'circles.new': "Novo círculo",
  'circles.edit': "Editar círculo",
  'circles.intro': "Agrupa os teus amigos (Família, Trabalho…) e publica só para eles.",
  'circles.empty': "Ainda não tens círculos",
  'circles.member': "membro",
  'circles.members': "membros",
  'circles.confirmDelete': "Eliminar este círculo? As publicações feitas para ele só serão visíveis para ti.",
  'circles.namePlaceholder': "Nome do círculo (ex. Família)",
  'circles.pickFriends': "Escolhe amigos",
  'circles.save': "Guardar",
  'circles.saved': "Círculo guardado",
  'circles.allFriends': "Todos os meus amigos",
  'circles.badge': "Círculo",
  'friends.one': 'Amigo',
  'friends.confirmRemove': "Tens a certeza de que queres remover este amigo?",
  'friends.privateProfile': 'Perfil privado',
  'friends.privateDesc': 'Este perfil e privado. Adicione como amigo para ver as publicacoes.',
  'friends.requests': 'Pedidos de amizade',
  'friends.noRequests': 'Sem pedidos pendentes',
  'suggestions.title': 'Pessoas que talvez conhecas',
  'suggestions.mutualFriends': 'amigos em comum',
  'suggestions.fromContacts': 'Dos teus contactos',
  'suggestions.newOnPapo': 'Novo no PAPO',
  'suggestions.noSuggestions': 'Sem sugestoes por agora',
  'suggestions.syncContacts': 'Sincronizar contactos',
  'suggestions.syncDesc': 'Encontra amigos do teu telemovel no PAPO',
  'suggestions.contactsSynced': 'Contactos sincronizados',
  'suggestions.synced': 'contactos sincronizados',
  'suggestions.syncError': 'Erro ao sincronizar contactos',
  'suggestions.manualPrompt': 'Introduz os emails ou telefones dos teus contactos separados por virgula:',
  'msg.ephemeral': 'Mensagem efemera',
  'msg.ephemeralToggle': 'Mensagem que desaparece apos leitura',
  'msg.ephemeralActive': 'Modo efemero ativado — as mensagens desaparecem apos leitura',
  'friendRequests.title': 'Pedidos de amizade',
  'friendRequests.nav': 'Pedidos',
  'friendRequests.incoming': 'Recebidos',
  'friendRequests.sent': 'Enviados',
  'friendRequests.noIncoming': 'Sem pedidos recebidos',
  'friendRequests.noSent': 'Sem pedidos enviados',
  'friendRequests.noFriends': 'Ainda nao tens amigos',
  'friendRequests.wantsToBeYourFriend': 'Quer ser teu amigo',
  'friendRequests.pendingSent': 'Pedido pendente',
  'friendRequests.remove': 'Remover',
  'friends.requestRejected': 'Pedido rejeitado',
  'profile.unfollow': 'Deixar de seguir',
  'profile.edit': 'Editar perfil',
  'profile.bio': 'Bio',
  // Common
  'common.loading': 'A carregar...',
  'common.now': 'agora mesmo',
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.close': 'Fechar',
  'common.back': 'Voltar',
  'common.min': 'min',
  'common.ago': 'ha',
  // PWA
  'pwa.install': 'Instalar App',
  'pwa.installDesc': 'Instala o PAPO no teu dispositivo',
  // Dashboard extra
  'dash.addBio': 'Adiciona uma bio para que outros te conhecam melhor.',
  'dash.viewProfile': 'Ver perfil',
  'dash.quickActions': 'Acoes rapidas',
  'dash.exploreGroups': 'Explorar grupos',
  'dash.viewEvents': 'Ver eventos',
  'dash.noPosts': 'Ainda nao ha publicacoes. Se o primeiro a partilhar!',
  'dash.reactError': 'Erro ao reagir',
  // Events extra
  'events.subtitle': 'Descobre experiencias que enriquecem a tua vida',
  'events.noEventsDay': 'Sem eventos neste dia',
  'groups.chat': 'Chat',
  'groups.noMessages': 'Sem mensagens ainda',
  'groups.typeMessage': 'Escreve uma mensagem...',
  'groups.noPosts': 'Sem publicações ainda. Compartilhe algo!',
  'chat.typing': 'está digitando...',
  'polls.create': 'Criar enquete',
  'polls.question': 'Pergunta...',
  'polls.option': 'Opção',
  'polls.addOption': 'Adicionar opção',
  'polls.publish': 'Publicar enquete',
  'polls.votes': 'votos',
  'help.title': 'Guia do PAPO',
  'help.subtitle': 'Tudo o que precisa saber para usar a rede social, passo a passo.',
  'help.contact': 'Tem dúvidas? Contacte',
  'help.start': 'Começar a usar o PAPO',
  'events.upcoming': 'Proximos eventos',
  'events.past': 'Eventos passados',
  'events.selectDate': 'Seleciona uma data',
  'events.noEventsDesc': 'Se o primeiro a organizar um evento para a comunidade!',
  'events.createFirst': 'Criar o primeiro evento',
  'events.confirmed': 'Confirmado',
  'events.participated': 'participaram',
  'events.locationOpt': 'Localizacao (opcional)',
  'events.titleLabel': 'Titulo do evento',
  // Groups extra
  'groups.subtitle': 'Conecta com comunidades que partilham os teus interesses',
  'groups.noGroupsFilter': 'Nao encontramos grupos com esses filtros',
  'groups.noGroupsDesc': 'Se o primeiro a criar um grupo!',
  'groups.createFirst': 'Criar o primeiro grupo',
  'groups.membersCount': 'membros',
  'groups.groupNamePh': 'Ex: Angolanos pela soberania',
  'groups.groupDescPh': 'De que trata o teu grupo?',
  'groups.processError': 'Erro ao processar o pedido',
  // Messages extra
  'msg.you': 'Tu',
  'msg.online': 'Online',
  'msg.today': 'Hoje',
  // Notifications
  'notif.title': 'Notificacoes',
  'notif.empty': 'Sem notificacoes',
  'notif.emptyDesc': 'Quando alguem interagir contigo, aparecera aqui.',
  'notif.markRead': 'Marcar como lidas',
  'notif.enableBrowser': 'Ativar notificacoes',
  'notif.enabled': 'Notificacoes ativadas',
  'notif.disabled': 'Notificacoes push desativadas',
  'notif.denied': 'Notificacoes bloqueadas. Ative-as nas configuracoes do navegador.',
  'notif.enablePush': 'Ativar push',
  'notif.pushActive': 'Push ativo',
  'notif.blocked': 'Bloqueado',
  'notif.reaction': 'reagiu a tua publicacao',
  'notif.comment': 'comentou na tua publicacao',
  'notif.follow': 'comecou a seguir-te',
  'notif.group': 'juntou-se ao teu grupo',
  // Post extra
  'post.createTitle': 'Criar publicacao',
  'post.placeholder': 'O que queres partilhar?',
  'post.posting': 'A publicar...',
  'post.publish': 'Publicar',
  'post.addImage': 'Adicionar imagem',
  // Report
  'report.title': 'Denunciar conteudo',
  'report.reason': 'Motivo da denuncia',
  'report.submit': 'Enviar denuncia',
  'report.success': 'Denuncia enviada. Obrigado.',
  // Donation extra
  'donation.support': 'Apoiar',
  // Share
  'post.share': 'Partilhar',
  'post.linkCopied': 'Link copiado!',
  'post.commentBtn': 'Comentar',
  // Admin
  'admin.title': 'Painel Admin',
  'admin.reports': 'Denuncias',
  'admin.users': 'Utilizadores',
  'admin.moderation': 'Moderacao',
  'admin.stats': 'Estatisticas',
  'admin.noReports': 'Sem denuncias pendentes',
  'admin.resolve': 'Resolver',
  'admin.dismiss': 'Arquivar',
  'admin.totalUsers': 'Total de utilizadores',
  'admin.totalPosts': 'Total de publicacoes',
  'admin.totalGroups': 'Total de grupos',
  'admin.pendingReports': 'Denuncias pendentes',
  // Theme
  'settings.darkMode': 'Modo escuro',
  'settings.lightMode': 'Modo claro',
  'settings.themeAuto': 'Automatico',
  'stories.addStory': 'Adicionar story',
  'stories.yourStory': 'Teu story',
  'stories.viewers': 'Visualizacoes',
  'stories.delete': 'Apagar',
  'stories.placeholder': 'Escreve algo...',
  'stories.create': 'Criar story',
  'stories.uploadMedia': 'Foto/Video',
  'stories.react': 'Reagir',
  'mention.placeholder': 'Mencionar @usuario',
  'trending.title': 'Em alta',
  'poll.vote': 'Votar',
  'poll.votes': 'votos',
  'poll.voted': 'Votaste',
  'poll.ended': 'Encerrada',
  'poll.createPoll': 'Criar enquete',
  'poll.question': 'Pergunta',
  'poll.option': 'Opcao',
  'poll.addOption': 'Adicionar opcao',
  'poll.duration': 'Duracao (horas)',
  'groupChat.title': 'Chat do grupo',
  'groupChat.send': 'Enviar',
  'groupChat.placeholder': 'Mensagem...',
  'groupChat.empty': 'Sem mensagens ainda. Se o primeiro!',
  // Post actions
  'post.deletePost': 'Eliminar publicacao',
  'post.reportContent': 'Reportar conteudo',
  'post.blockUser': 'Bloquear utilizador',
  'post.reactions': 'reacoes',
  'post.tips': 'gorjeta',
  'post.tipsPlural': 'gorjetas',
  'post.comments': 'comentarios',
  'post.firstComment': 'Se o primeiro a comentar',
  'post.commentPlaceholder': 'Escreve um comentario...',
  'post.postDeleted': 'Publicacao eliminada',
  'post.postDeleteError': 'Erro ao eliminar publicacao',
  'post.blockSuccess': 'Utilizador bloqueado',
  'post.blockError': 'Erro ao bloquear utilizador',
  'post.copyError': 'Erro ao copiar',
  'post.commentError': 'Erro ao publicar comentario',
  'post.loadCommentsError': 'Erro ao carregar comentarios',
  'post.moderationWarning': 'Aviso de moderacao:',
  'post.contentHidden': 'Conteudo ocultado por moderacao',
  'post.publicPost': 'Publicacao publica',
  'post.groupPost': 'Publicacao no grupo',
  'post.fileNotAllowed': 'Tipo de ficheiro nao permitido',
  'post.writeOrAdd': 'Escreve algo ou adiciona um ficheiro',
  'post.created': 'Publicacao criada!',
  'post.createError': 'Erro ao criar a publicacao',
  'post.uploaded': 'enviado',
  'post.formDesc': 'Formulario para criar uma nova publicacao',
  // Dashboard
  'dash.noGroups': 'Nao ha grupos disponiveis',
  'dash.noEvents': 'Nao ha eventos proximos',
  'dash.conecta': 'Conecta e satisfaz as tuas necessidades',
  'dash.simbinDesc': 'Rede de entretenimento africano',
  'dash.assertiveDesc': 'Plataforma de networking profissional',
  // Trending
  'trending.posts': 'posts',
  // Stories
  'stories.photoVideoOnly': 'Apenas fotos ou videos',
  'stories.created': 'Story criado!',
  'stories.error': 'Erro',
  // Search
  'search.placeholder': 'Procurar pessoas, posts, grupos, #hashtags...',
  // Messages
  'msg.searchPeople': 'Procurar pessoas...',
  'msg.writePlaceholder': 'Escreve uma mensagem...',
  // Group detail
  'groups.members': 'Miembros',
  // Tip
  'tip.send': 'Enviar gorjeta',
  'tip.placeholder': 'Quantia',
  'tip.error': 'Erro ao enviar gorjeta',
  'tip.amountError': 'Introduz uma quantia valida',
  // Donation
  'donation.title': 'Isto e so o inicio',
  'donation.subtitle': 'O PAPO precisa da tua ajuda',
  'donation.copy': 'Copiar',
  'donation.copied': 'Copiado!',
  'donation.addresses': 'Enderecos de doacoes',
  // Report extra
  'report.sent': 'Reporte enviado',
  'report.close': 'Fechar',
  'report.minChars': 'Seleciona uma categoria e descreve o problema (minimo 10 caracteres)',
  'report.title': 'Reportar conteudo',
  'report.legalNote': 'O teu reporte sera analisado conforme o Direito Internacional e a legislacao da UE.',
  'report.categoryLabel': 'Categoria do reporte',
  'report.categoryPlaceholder': 'Seleciona uma categoria...',
  'report.descLabel': 'Descricao',
  'report.descPlaceholder': 'Descreve o problema em detalhe (minimo 10 caracteres)...',
  'report.urgentNote': 'Se ha risco imediato para a vida, contacta os servicos de emergencia locais. Os reportes urgentes sao escalados automaticamente.',
  'report.submit': 'Enviar reporte',
  'report.submitting': 'A enviar...',
  'report.received': 'Reporte recebido',
  'report.priority': 'Prioridade',
  'report.urgent': 'Urgente',
  'report.standard': 'Padrao',
  'report.legalFrameworks': 'Marcos legais aplicaveis',
  'report.submitError': 'Erro ao enviar o reporte',
  // Report categories
  'report.cat.spam': 'Spam',
  'report.cat.harassment': 'Assedio',
  'report.cat.cyberbullying': 'Ciberbullying',
  'report.cat.threats': 'Ameacas',
  'report.cat.hate_speech': 'Discurso de odio',
  'report.cat.discrimination': 'Discriminacao',
  'report.cat.incitement_violence': 'Incitacao a violencia',
  'report.cat.child_abuse': 'Abuso infantil',
  'report.cat.child_exploitation': 'Exploracao infantil',
  'report.cat.child_grooming': 'Grooming',
  'report.cat.human_trafficking': 'Trafico de pessoas',
  'report.cat.sexual_exploitation': 'Exploracao sexual',
  'report.cat.terrorism': 'Terrorismo',
  'report.cat.extremism': 'Extremismo',
  'report.cat.self_harm': 'Autolesao',
  'report.cat.suicide': 'Suicidio',
  'report.cat.fraud': 'Fraude',
  'report.cat.scam': 'Burla',
  'report.cat.doxxing': 'Doxxing',
  'report.cat.privacy_violation': 'Violacao de privacidade',
  'report.cat.misinformation': 'Desinformacao',
  'report.cat.other': 'Outro',
  // Report groups
  'report.group.general': 'Geral',
  'report.group.cybercrime': 'Cibercrime',
  'report.group.discrimination': 'Discriminacao e odio',
  'report.group.child_safety': 'Protecao infantil',
  'report.group.trafficking': 'Trafico de pessoas',
  'report.group.terrorism': 'Terrorismo',
  'report.group.safety': 'Seguranca pessoal',
  'report.group.fraud': 'Fraude',
  // Post additional
  'post.createTitle': 'Criar publicacao',
  'post.placeholder': 'O que queres partilhar',
  'post.addImage': 'Imagem',
  'post.posting': 'A publicar...',
  'post.publish': 'Publicar',
  'post.commentBtn': 'Comentar',
  'post.share': 'Partilhar',
  'post.tip': 'Gorjeta',
  'post.linkCopied': 'Link copiado!',
  // Search extra
  'search.popularTags': 'Hashtags populares',
  'search.noResults': 'Sem resultados para',
  'search.publishHashtags': 'Publica com #hashtags para que aparecam aqui',
  'search.people': 'Pessoas',
  'search.posts': 'Publicacoes',
  'search.groups': 'Grupos',
  'search.events': 'Eventos',
  'search.hashtags': 'Hashtags',
  'search.membersCount': 'membros',
  // Tip extra
  'tip.title': 'Enviar gorjeta',
  'tip.desc': 'Apoia {name} com uma gorjeta crypto',
  'tip.chain': 'Cadeia',
  'tip.amount': 'Quantia',
  'tip.message': 'Mensagem (opcional)',
  'tip.messagePlaceholder': 'Otimo conteudo!',
  'tip.sent': 'Gorjeta enviada',
  'tip.note': 'As gorjetas sao simbolicas e registadas na plataforma.',
  // Donation extra
  'donation.body': 'Para melhorar e manter a nossa comunidade segura, precisamos de apoio financeiro para nos protegermos legalmente e cobrir os gastos de estrutura.',
  'donation.addressCopied': 'Endereco copiado!',
  'donation.close': 'Entendido, obrigado!',
  'donation.footer': 'Cada contribuicao ajuda a manter o PAPO como um espaco digital seguro, livre e comprometido com o futuro de Angola.',
  // Common error
  'common.error': 'Erro',
  // Reactions
  'reaction.empower': 'Empoderar',
  'reaction.support': 'Apoiar',
  'reaction.inspire': 'Inspirar',
  'reaction.peace': 'Paz',
  // Profile page
  'profile.loadError': 'Erro ao carregar o perfil',
  'profile.unfollowed': 'Deixaste de seguir este utilizador',
  'profile.followed': 'Agora segues este utilizador',
  'profile.listError': 'Erro ao carregar a lista',
  'profile.reactionError': 'Erro ao reagir',
  'profile.updated': 'Perfil atualizado',
  'profile.updateError': 'Erro ao atualizar o perfil',
  'profile.photoUpdated': 'Foto atualizada',
  'profile.photoError': 'Erro ao enviar a imagem',
  'profile.memberSince': 'Membro do PAPO',
  'profile.mutualFriends': 'amigos em comum',
  'profile.noPosts': 'Ainda nao publicaste nada. Partilha algo com a comunidade!',
  'profile.noPostsOther': 'Este utilizador ainda nao publicou nada.',
  // Groups page
  'groups.catAll': 'Todos',
  'groups.catGeneral': 'Geral',
  'groups.catWellness': 'Bem-estar',
  'groups.catMindfulness': 'Consciencia',
  'groups.catCreativity': 'Criatividade',
  'groups.catSupport': 'Apoio',
  'groups.catLearning': 'Aprendizagem',
  // Group detail
  'groupDetail.loadError': 'Erro ao carregar o grupo',
  'groupDetail.left': 'Saiste do grupo',
  'groupDetail.joined': 'Entraste no grupo',
  'groupDetail.actionError': 'Erro ao processar o pedido',
  'groupDetail.reactionError': 'Erro ao reagir',
  // Settings page
  'settings.tabProfile': 'Perfil',
  'settings.tabWellness': 'Bem-estar',
  'settings.tabNotifications': 'Notificacoes',
  'settings.tabPrivacy': 'Privacidade',
  'settings.tabLegal': 'Legal / RGPD',
  'settings.tabAppearance': 'Aparencia',
  'settings.saved': 'Perfil atualizado',
  'settings.saveError': 'Erro ao guardar as alteracoes',
  'settings.imageTooBig': 'A imagem nao pode superar 5MB',
  'settings.photoUpdated': 'Foto atualizada',
  'settings.photoError': 'Erro ao enviar a imagem',
  'settings.deleteRequested': 'Pedido de eliminacao registado',
  'settings.deleteError': 'Erro ao solicitar eliminacao',
  'settings.deleteCancelled': 'Pedido de eliminacao cancelado',
  // Messages
  'msg.blockError': 'Erro ao bloquear utilizador',
  'msg.caller': 'Utilizador',
  'msg.userNotFound': 'Utilizador nao encontrado',
  'msg.blockedFromMsg': 'Bloqueado desde mensagens',
  'msg.userBlocked': 'Utilizador bloqueado',
  'msg.yourMessages': 'As tuas mensagens',
  'msg.selectOrSearch': 'Seleciona uma conversa ou procura alguem para conversar',
  'msg.noChatsYet': 'Nao tens conversas',
  'msg.searchToChat': 'Procura pessoas para iniciar um chat',
  'msg.startConvo': 'Inicia a conversa',
  'bluetooth.papoUser': 'Utilizador PAPO',
  // Settings content
  'settings.bioPlaceholder': 'Conta-nos sobre ti...',
  'settings.save': 'Guardar alteracoes',
  'settings.currentSession': 'Sessao atual',
  'settings.maxDaily': 'Tempo maximo diario',
  'settings.privacyTitle': 'Privacidade e seguranca',
  'settings.deleteAccount': 'Eliminar a minha conta',
  'settings.cancelDelete': 'Cancelar eliminacao',
  'settings.requestDelete': 'Solicitar eliminacao da conta',
  'settings.deleteConfirmTitle': 'Eliminar conta permanentemente',
  'settings.cancel': 'Cancelar',
  'settings.exportError': 'Erro ao exportar dados',
  'settings.title': 'Configuracoes',
  'settings.logout': 'Terminar sessao',
  'settings.profileInfo': 'Informacao do perfil',
  'settings.nameLabel': 'Nome',
  'settings.wellnessConfig': 'Configuracao de bem-estar digital',
  'settings.exportData': 'Exportar os meus dados',
  'settings.legalInfo': 'Informacao legal',
  'settings.dpo': 'Encarregado de protecao de dados',
  'settings.themeLabel': 'Tema',
  'settings.themeApplied': 'Tema aplicado',
  'settings.exportSuccess': 'Dados exportados com sucesso',
  'account.title': 'Gestão de conta',
  'account.subtitle': 'Proteção de dados e privacidade (RGPD)',
  'account.exportTitle': 'Baixar meus dados',
  'account.exportDesc': 'Baixe todas as suas publicações, mensagens, contatos e dados em um arquivo ZIP compactado. Direito de portabilidade (RGPD Art. 20).',
  'account.downloadZip': 'Baixar ZIP',
  'account.deactivateTitle': 'Desativar conta',
  'account.deactivateDesc': 'Seu perfil não será visível e você não poderá fazer login. Seus dados são preservados.',
  'account.deactivateBtn': 'Desativar minha conta',
  'account.deleteTitle': 'Excluir conta permanentemente',
  'account.deleteDesc': 'Exclui todas as suas informações de forma irreversível após 30 dias de carência. Direito ao esquecimento (RGPD Art. 17).',
  'account.deleteBtn': 'Excluir minha conta',
  'account.deleteConfirm': 'Excluir em 30 dias',
  'account.legalNotice': 'Os seus direitos de proteção de dados são garantidos pelo Regulamento Geral de Proteção de Dados (RGPD). Para consultas: dpo@papo.social',
  'account.exportSuccess': 'Dados baixados',
  'account.exportError': 'Erro ao exportar dados',
  'account.exporting': 'Gerando...',
  'account.deactivateConfirmTitle': 'Desativar sua conta?',
  'account.deactivateConfirmDesc': 'Seu perfil não será visível para outros usuários. Você não poderá fazer login até que a conta seja reativada. Seus dados serão preservados.',
  'account.deactivateConfirm': 'Sim, desativar',
  'account.deactivated': 'Conta desativada',
  'account.deleteConfirmTitle': 'Excluir sua conta permanentemente?',
  'account.deleteConfirmDesc1': 'Esta ação é irreversível. Após 30 dias serão excluídos:',
  'account.deleteItem1': 'Seu perfil e informações pessoais',
  'account.deleteItem2': 'Todas as suas publicações e comentários',
  'account.deleteItem3': 'Suas mensagens e conversas',
  'account.deleteItem4': 'Membros de grupos e contatos',
  'account.deleteConfirmDesc2': 'Recomendamos baixar seus dados antes de excluir a conta.',
  'account.deleteScheduled': 'Exclusão agendada para 30 dias',
  'account.deletionPending': 'Exclusão agendada',
  'account.deletionDate': 'Data:',
  'account.cancelDeletion': 'Cancelar exclusão',
  'account.deletionCancelled': 'Exclusão cancelada',
  'account.error': 'Erro ao processar',
  'privacy.visibility': 'Visibilidade',
  'privacy.public': 'Público',
  'privacy.private': 'Privado (apenas contatos)',
  'privacy.hidden': 'Oculto',
  'privacy.inviteContacts': 'Convidar contatos',
  'privacy.searchContact': 'Buscar contato...',
  'privacy.noContacts': 'Sem contatos',
  'settings.username': 'Nome de usuário',
  'settings.usernameDesc': 'Um alias público que outros podem ver em vez do seu nome real.',
  'settings.showEmail': 'Mostrar email no perfil',
  'settings.showEmailDesc': 'Permite que outros usuários vejam seu email no seu perfil.',
  'settings.profileVisible': 'Perfil visível',
  'settings.profileVisibleDesc': 'Oculte seu perfil de pesquisas e visitas.',
  'settings.saved': 'Salvo',
  'settings.save': 'Salvar',
  'profile.followersTooltip': 'Pessoas que seguem este perfil',
  'profile.followingTooltip': 'Pessoas que este perfil segue',
  'profile.friendsTooltip': 'Amizades mútuas',
  'profile.mutualTooltip': 'Amigos em comum',
  'friends.removeFriendTooltip': 'Remover amizade',
  'friends.pendingTooltip': 'Solicitação enviada, aguardando resposta',
  'friends.acceptTooltip': 'Aceitar pedido de amizade',
  'friends.addFriendTooltip': 'Enviar pedido de amizade',
  'suggestions.friendOfFriend': 'Amigo dos seus amigos',
  'settings.downloadBtn': 'Descarregar os meus dados',
  // Settings - Wellness tab
  'settings.wellnessIntro': 'O PAPO ajuda-te a manter um uso saudavel das redes sociais.',
  'settings.breakReminders': 'Lembretes de descanso',
  'settings.breakInterval': 'Intervalo de descanso',
  'settings.dailyLimit': 'Limite diario de uso',
  'settings.breakSound': 'Som suave ao sugerir descansos',
  'settings.breakModeInfo': 'Sobre o modo descanso: Quando ativado, veras um exercicio de respiracao guiado com animacoes relaxantes. Podes terminar o descanso a qualquer momento.',
  // Settings - Notifications tab
  'settings.notifReactions': 'Reacoes',
  'settings.notifComments': 'Comentarios',
  'settings.notifFollowers': 'Novos seguidores',
  'settings.notifMessages': 'Mensagens',
  'settings.notifMentions': 'Mencoes',
  'settings.notifGroups': 'Atividade de grupos',
  'settings.pushNotif': 'Notificacoes push',
  'settings.pushNotifDesc': 'Receber notificacoes no browser',
  'settings.enablePush': 'Ativar notificacoes push',
  'settings.disablePush': 'Desativar notificacoes push',
  // Settings - Privacy tab
  'settings.publicProfile': 'Perfil publico',
  'settings.publicProfileDesc': 'Qualquer pessoa pode ver o teu perfil',
  'settings.showOnline': 'Mostrar estado online',
  'settings.showLastSeen': 'Mostrar ultima visita',
  'settings.blockedUsers': 'Utilizadores bloqueados',
  'settings.blockedNone': 'Nao tens utilizadores bloqueados',
  'settings.unblock': 'Desbloquear',
  // Settings - Legal tab
  'settings.legalCommitment': 'Cumprimos com o RGPD, a Lei de Servicos Digitais (DSA), a Convencao dos Direitos da Crianca, o Protocolo de Palermo, a Convencao de Budapeste e as resolucoes do Conselho de Seguranca da ONU.',
  'settings.legalCommitmentTitle': 'Compromisso legal do PAPO:',
  // Settings - Notifications descriptions
  'settings.notifReactionsDesc': 'Quando alguem reage as tuas publicacoes',
  'settings.notifCommentsDesc': 'Quando alguem comenta nas tuas publicacoes',
  'settings.notifMessagesDesc': 'Quando recebes uma mensagem nova',
  'settings.notifEvents': 'Eventos',
  'settings.notifEventsDesc': 'Lembretes de eventos proximos',
  'settings.notifGroupsDesc': 'Novas publicacoes nos teus grupos',
  'settings.wellnessTip': 'Dica de bem-estar:',
  'settings.wellnessTipText': 'Limitar as notificacoes pode ajudar-te a reduzir a ansiedade digital e melhorar a tua concentracao.',
  // Settings - Privacy
  'settings.privacyIntro': 'A tua privacidade e a nossa prioridade. O PAPO nunca vendera os teus dados.',
  'settings.publicProfileDesc2': 'Outros utilizadores podem ver o teu perfil',
  'settings.showOnlineDesc': 'Outros veem quando estas ligado',
  'settings.allowDM': 'Permitir mensagens diretas',
  'settings.allowDMDesc': 'Qualquer pessoa pode enviar-te mensagens',
  'settings.privacyCommitTitle': 'Compromisso PAPO:',
  'settings.privacyCommitText': 'Os teus dados pessoais nunca serao vendidos nem utilizados para publicidade. So os usamos para melhorar a tua experiencia.',
  // Settings - Legal  
  'settings.legalTitle': 'Direitos legais e protecao de dados',
  'settings.legalIntro': 'O PAPO cumpre com o RGPD, a Lei de Servicos Digitais da UE e o Direito Internacional Publico.',
  'settings.legalExportDesc': 'Descarrega uma copia completa de todos os teus dados pessoais: perfil, publicacoes, comentarios, mensagens, grupos e reacoes.',
  'settings.exporting': 'A exportar...',
  'settings.legalDeleteDesc': 'A tua conta sera eliminada permanentemente apos 30 dias. Todos os teus dados serao removidos.',
  'settings.deleteWarning': 'Tem a certeza? Esta acao e irreversivel. A tua conta e todos os teus dados serao eliminados permanentemente.',
  'settings.deleteConfirm': 'Eliminar permanentemente',
  'settings.euRep': 'Representante UE',
  'settings.disputes': 'Resolucao de litígios',
  'settings.odrEU': 'ODR da UE',
  'settings.transparencyReport': 'Relatorio de transparencia',
  'settings.viewReport': 'Ver relatorio',
  'settings.aiModeration': 'Moderacao IA',
  'settings.aiModDesc': 'O conteudo e analisado automaticamente por IA',
  'settings.analyzed': 'Analisados',
  'settings.approved': 'Aprovados',
  'settings.warned': 'Avisados',
  'settings.hidden': 'Ocultos/Escalados',
  'settings.loadingStats': 'A carregar estatisticas...',
  'settings.dailyUsage': 'Uso diario',
  'settings.breakDesc': 'Sugerir pausas apos um tempo de uso',
  'settings.breakEvery': 'Sugerir pausa a cada {min} minutos',
  'settings.dailyLimitDesc': 'Receber alerta ao aproximar-se do limite',
  'settings.alertAt': 'Alerta quando atingires {min} minutos',
  'settings.wellnessSounds': 'Sons de bem-estar',
  'settings.notifTitle': 'Preferencias de notificacoes',
  'settings.notifDesc': 'Configura que notificacoes queres receber para manter um uso saudavel da plataforma.',
  'settings.appearanceTitle': 'Aparencia',
  'settings.appearanceDesc': 'Personaliza como o PAPO aparece para ti.',
  'settings.appearanceTip': 'Dica: Todos os temas estao otimizados para uma leitura prolongada e o modo Escuro reduz a emissao de luz azul.',
  'settings.saving': 'A guardar...',
  'settings.hours': 'horas',
  // Theme labels
  'theme.light': 'Claro',
  'theme.dark': 'Escuro',
  'theme.midnight': 'Meia-Noite',
  'theme.resistance': 'Resistencia',
  // Settings extras
  'settings.cancelError': 'Erro ao cancelar pedido',
  'settings.userUnblocked': 'Utilizador desbloqueado',
  'settings.unblockError': 'Erro ao desbloquear utilizador',
  'settings.accountWillDelete': 'A tua conta sera eliminada a {date}.',
  'settings.blockedOn': 'Bloqueado a {date}',
  'settings.bioLabel': 'Bio',
  // Wallet
  'wallet.loadError': 'Erro ao carregar a carteira',
  'wallet.demoFunded': 'Carteira demo financiada',
  'wallet.fundError': 'Erro ao financiar',
  'wallet.sendError': 'Erro na transferencia',
  'wallet.swapError': 'Erro no swap',
  'wallet.stakeError': 'Erro no staking',
  'wallet.unstakeError': 'Erro',
  'wallet.metamaskNotFound': 'MetaMask nao detetado. Instala a extensao.',
  'wallet.metamaskConnected': 'MetaMask conectado',
  'wallet.metamaskError': 'Erro ao conectar MetaMask',
  'wallet.tabPortfolio': 'Portfolio',
  'wallet.tabMarket': 'Mercado',
  'wallet.tabHistory': 'Historico',
  'wallet.tabStaking': 'Staking',
  'wallet.emptyWallet': 'A tua carteira esta vazia',
  'wallet.fundDemo': 'Fondear wallet demo',
  'wallet.activeStaking': 'Staking ativo',
  'wallet.withdraw': 'Retirar',
  'wallet.availableStaking': 'Disponivel para staking',
  'wallet.upToAPY': 'Ate {apy}% APY',
  'wallet.bricsBanner': 'Pagos QR multi-pais BRICS+ — 600+ criptomoedas',
  'wallet.sendCrypto': 'Enviar crypto',
  'wallet.sendDesc': 'Transferencia P2P entre utilizadores PAPO',
  'wallet.cryptocurrency': 'Criptomoeda',
  'wallet.selectPlaceholder': 'Selecionar...',
  'wallet.available': 'disponivel',
  'wallet.recipientId': 'ID do destinatario',
  'wallet.amount': 'Quantidade',
  'wallet.noteOptional': 'Nota (opcional)',
  'wallet.sending': 'A enviar...',
  'wallet.sendBtn': 'Enviar',
  'wallet.sentTo': 'Enviado a {name}',
  'wallet.receivedFrom': 'Recebido de {name}',
  'wallet.swapDesc': 'Trocar criptomoedas — 0.3% fee',
  'wallet.from': 'De',
  'wallet.to': 'A',
  'wallet.youWillReceive': 'Vais receber',
  'wallet.rate': 'Taxa',
  'wallet.swapping': 'A trocar...',
  'wallet.confirmSwap': 'Confirmar swap',
  'wallet.stakeDesc': 'Ganha rendimento sobre as tuas criptomoedas',
  'wallet.annualYield': 'Rendimento anual estimado',
  'wallet.stakingProgress': 'A fazer staking...',
  'wallet.confirmStaking': 'Confirmar staking',
  'wallet.noTransactionsYet': 'Sem transacoes ainda',
  'wallet.inspired': 'Inspirada em',
  // Profile extras
  'profile.noPhotos': 'Ainda nao tens fotos. Partilha imagens com a comunidade!',
  'profile.noPhotosOther': 'Este utilizador ainda nao partilhou imagens.',
  'profile.editTitle': 'Editar perfil',
  'profile.nameLabel': 'Nome',
  'profile.bioLabel': 'Bio',
  'profile.bioPlaceholder': 'Conta-nos sobre ti...',
  'profile.saveChanges': 'Guardar alteracoes',
  'profile.searchByName': 'Pesquisar por nome',
  'profile.noMutual': 'Sem amigos em comum',
  'profile.mutualTitle': 'Amigos em comum',
  'profile.followBack': "Seguir de volta",
  'profile.followsYou': "Segue você",
  'profile.peopleYouMayKnow': "Pessoas que talvez você conheça",
  'profile.mutualFriend': "amigo em comum",
  'search.recent': "Pesquisas recentes",
  'search.clearAll': "Limpar tudo",
  'notif.view': "Ver",
  'search.discover': "Pesquisar",
  'onboarding.skip': 'Pular',
  'onboarding.prev': 'Anterior',
  'onboarding.next': 'Próximo',
  'onboarding.finish': 'Vamos lá!',
  'onboarding.home.title': 'Início',
  'onboarding.home.desc': 'O seu feed: publicações de amigos e pessoas que segue, ordenadas por quem mais interage consigo.',
  'onboarding.explore.title': 'Explorar',
  'onboarding.explore.desc': 'Descubra publicações, reels e temas novos para além do seu círculo.',
  'onboarding.messages.title': 'Mensagens',
  "onboarding.messages.desc": "Conversa em privado em tempo real, com voz e videochamadas. Mantém premida uma mensagem para reagir ou toca em ↩ para responder.",
  'onboarding.lives.title': 'Lives',
  "onboarding.lives.desc": "Vê diretos ou transmite o teu, recebe presentes e usa emojis e stickers afro no chat.",
  'onboarding.wallet.title': 'Wallet',
  'onboarding.wallet.desc': 'A sua carteira multichain: saldos, enviar e receber cripto e gorjetas.',
  'onboarding.search.title': 'Pesquisar',
  'onboarding.search.desc': 'Encontre pessoas, publicações, grupos e hashtags. As suas pesquisas recentes ficam aqui.',
  'onboarding.notifications.title': 'Notificações',
  'onboarding.notifications.desc': 'Veja na hora reações, comentários e pedidos de amizade.',
  'onboarding.wellness.title': 'Bem-estar',
  'onboarding.wellness.desc': 'Acompanhe o seu tempo de uso diário e faça uma pausa quando precisar.',
  'onboarding.profile.title': 'Perfil',
  "onboarding.profile.desc": "Edita o teu perfil e vê os teus amigos. Neste menu encontras o Guia do PAPO e as novidades.",
  'landing.slides.kicker': 'Tudo o que pode fazer',
  'landing.slides.heading': 'Descubra o PAPO, função a função',
  'landing.slides.feed.title': 'Feed inteligente',
  'landing.slides.feed.desc': 'O seu início aprende com quem mais interage e mostra primeiro o que realmente importa de amigos e de quem segue.',
  'landing.slides.wellness.title': 'Bem-estar digital',
  'landing.slides.wellness.desc': 'Temporizador, limite diário e pausas guiadas para que a rede social lhe devolva tempo em vez de o tirar.',
  'landing.slides.lives.title': 'Lives com convidados',
  'landing.slides.lives.desc': 'Transmita ao vivo, convide alguém para ecrã partilhado e receba reações e gorjetas em tempo real.',
  'landing.slides.offline.title': 'Mensagens sem internet',
  'landing.slides.offline.desc': 'Converse por Bluetooth de telemóvel para telemóvel sem rede: ideal para zonas rurais e emergências.',
  'landing.slides.stickers.title': 'Stickers afrocêntricos',
  'landing.slides.stickers.desc': 'Expresse a sua identidade com stickers animados inspirados nas culturas africanas, do Sahel ao Atlas e ao Cabo.',
  'landing.slides.wallet.title': 'Carteira multichain',
  'landing.slides.wallet.desc': 'Guarde, envie e receba cripto em várias redes e apoie criadores com gorjetas diretas.',
  'landing.slides.privacy.title': 'Privacidade em primeiro',
  'landing.slides.privacy.desc': 'Os seus dados são seus: perfis privados, bloqueio, denúncias e cumprimento rigoroso da proteção de dados.',
  'landing.slides.groups.title': 'Grupos e eventos',
  'landing.slides.groups.desc': 'Crie comunidades, organize encontros e celebre com a sua gente, online e pessoalmente.',
  'landing.slides.explore.title': 'Pesquisar e Explorar',
  'landing.slides.explore.desc': 'Encontre pessoas, publicações, grupos e hashtags em tendência, com filtros e pesquisas recentes.',
  'landing.slides.languages.title': '4 idiomas e tema duplo',
  'landing.slides.languages.desc': 'O PAPO fala português, inglês, espanhol e francês, com modo claro e escuro à sua escolha.',
  'landing.slides.try': 'Experimente',
  'landing.demo.feed': 'O seu feed',
  'landing.demo.react': 'Reações',
  'landing.demo.live': 'Ao vivo',
  'landing.demo.chat': 'Mensagens',
  'landing.demo.guest': 'Convidada',
  'landing.demo.msg1': 'Chegaste bem a Tamanrasset?',
  'landing.demo.msg2': 'Sim! Sem rede, mas o PAPO funciona por Bluetooth 🙌🏽',
  'landing.demo.offline': 'Enviado sem internet',
  'testimonials.kicker': 'Vozes da comunidade',
  'testimonials.heading': 'De Dakar ao Atlas, é isto que a nossa gente diz',
  'testimonials.formTitle': 'Partilhe a sua experiência',
  'testimonials.formDesc': 'Conte-nos o que o PAPO significa para si. Depois de aprovado pela equipa, aparecerá na página inicial com o seu nome e cidade.',
  'testimonials.quote': 'O seu testemunho',
  'testimonials.quotePlaceholder': 'Mínimo 20 caracteres...',
  'testimonials.city': 'Cidade',
  'testimonials.country': 'País',
  'testimonials.submit': 'Enviar testemunho',
  'testimonials.update': 'Atualizar testemunho',
  'testimonials.delete': 'Eliminar',
  'testimonials.sent': 'Obrigado! O seu testemunho está em revisão',
  'testimonials.status.pending': 'Em revisão',
  'testimonials.status.approved': 'Aprovado',
  'testimonials.status.rejected': 'Rejeitado',
  'testimonials.status.all': 'Todos',
  'testimonials.adminTab': 'Testemunhos',
  'testimonials.approve': 'Aprovar',
  'testimonials.reject': 'Rejeitar',
  'testimonials.none': 'Sem testemunhos aqui',
  'settings.tabCommunity': 'Comunidade e ajuda',
  'settings.replayGuide': 'Ver guia novamente',
  'settings.replayGuideDesc': 'Repita o percurso pelos botões principais do PAPO quando quiser.',
  'settings.replayGuideBtn': 'Ver guia',
  'admin.signupSources': 'Registos por função (Experimente)',
  'admin.noSignupSources': 'Ainda não há registos a partir do carrossel',
  'auth.regNamePh': 'O teu nome',
  'auth.regEmailPh': 'teu@email.com',
  'auth.regPassPh': 'Mínimo 6 caracteres',
  'auth.regConfirmPh': 'Repete a tua palavra-passe',
  'auth.regOrWith': 'ou regista-te com',
  'upload.optimized': 'Foto otimizada',
  'stream.share': 'Partilhar',
  'stream.shareTitle': 'Partilhar live',
  'stream.shareText': 'Junta-te ao meu live no PAPO!',
  'stream.searchPeople': 'Pesquisar amigos e pessoas que segues',
  'stream.noPeople': 'Sem pessoas para mostrar',
  'stream.sendTo': 'Enviar',
  'stream.sharedWith': 'Live enviado a',
  'stream.copyLink': 'Copiar link',
  'stream.linkCopied': 'Link copiado!',
  'stream.more': 'Mais',
  'stream.tapForSound': 'Toca para ativar o som',
  'stream.ended': 'Este live já terminou',
  'stream.removeGuest': 'Remover convidado',
  'stream.youWereRemoved': 'O host removeu-te do live',
  'stream.guestsFull': 'Este live já tem 4 convidados',
  'stream.weakConnection': 'A tua ligação está fraca: o vídeo pode parar',
  'stream.quality.good': 'Boa ligação',
  'stream.quality.fair': 'Ligação razoável',
  'stream.quality.poor': 'Má ligação',
  'stream.latency': 'Latência',
  'stream.packetLoss': 'Perda de pacotes',
  'stream.cover': 'Capa (opcional)',
  'stream.coverHint': 'Aparece ao partilhar o link no WhatsApp ou Facebook',
  'stream.notifyFollowers': 'Avisar os meus amigos',
  'stream.followersNotified': 'Amigos avisados',
  'stream.followersAlreadyNotified': 'Já avisaste os teus amigos neste live',
  'stream.askToJoin': 'Pedir para entrar',
  'stream.cancelRequest': 'Cancelar',
  'stream.joinRequests': 'Pedidos',
  'stream.wantsToJoin': 'quer entrar no live',
  'stream.requestRejected': 'O host recusou o teu pedido. Podes pedir de novo em 30 s',
  'stream.accept': 'Aceitar',
  'stream.reject': 'Recusar',
  'stream.liveNow': 'Ao vivo',
  'profile.noFollowers': 'Sem seguidores ainda',
  'profile.notFollowing': 'Nao segue ninguem ainda',
  'profile.reactions': 'reacoes',
  'profile.gallery': 'Galeria',
  'profile.whatToShare': 'O que queres partilhar, {name}?',
  'post.video': 'Video',
  'post.photo': 'Foto',
  'post.link': 'Link',
  // VideoCall
  'videoCall.connecting': 'A conectar...',
  'videoCall.ringing': 'A ligar...',
  'videoCall.media': 'Permita o acesso ao microfone para ligar.',
  'videoCall.connection': 'A ligação foi interrompida. Tente ligar novamente.',
  'videoCall.timeout': 'Sem resposta. Tente novamente mais tarde.',
  'videoCall.rejected': 'A chamada foi recusada ou a pessoa está ocupada.',
  'videoCall.ended': 'Chamada terminada',
  // Bluetooth
  'bluetooth.enable': 'Ativar',
  'bluetooth.disable': 'Desativar',
  'bluetooth.searchPeers': 'Procura peers proximos para conectar',
  'bluetooth.noMessages': 'Sem mensagens ainda. Envia a primeira!',
  'bluetooth.panicTitle': 'Modo panico - Eliminar todos os dados',
  'bluetooth.tagline': 'Sem internet - Sem censura - Encriptado ponto a ponto',
  'bluetooth.nearbyPeers': 'Peers proximos',
  // Groups
  'groups.joinToPost': 'Junta-te ao grupo para ver e criar publicacoes.',
  // Auth
  'auth.authError': 'Erro na autenticacao',
  // Live Streaming
  'stream.title': 'Live Streaming',
  'stream.subtitle': 'Transmissoes ao vivo da comunidade PAPO',
  'stream.category': 'Categoria',
  'stream.allLives': 'Todas',
  'stream.cat.general': 'Geral',
  'stream.cat.music': 'Musica',
  'stream.cat.talk': 'Conversa',
  'stream.cat.gaming': 'Jogos',
  'stream.cat.cooking': 'Culinaria',
  'stream.cat.education': 'Educacao',
  'stream.cat.fitness': 'Fitness',
  'stream.cat.culture': 'Cultura',
  'stream.goLive': 'Ir ao vivo',
  'stream.goLiveDesc': 'Inicia uma transmissao ao vivo para a comunidade',
  'stream.titleLabel': 'Titulo',
  'stream.titlePlaceholder': 'Da um titulo a tua transmissao...',
  'stream.descLabel': 'Descricao',
  'stream.descPlaceholder': 'Do que vais falar?',
  'stream.privacy': 'Privacidade',
  'stream.public': 'Publico',
  'stream.private': 'Privado',
  'stream.startStreaming': 'Comecar a transmitir',
  'stream.createError': 'Erro ao criar transmissao',
  'stream.end': 'Terminar',
  'stream.guestJoined': 'entrou no live!',
  'stream.guestDeclined': 'recusou o convite',
  'stream.guestInviteTitle': 'Convite para participar no Live',
  'stream.guestInviteDesc': 'O anfitriao convida-te a participar com camera e microfone. Todos os espectadores vao ver-te e ouvir-te.',
  'stream.guestAccepted': 'Entraste no live! A tua camera esta ativa.',
  'stream.joinLive': 'Entrar no Live',
  'stream.decline': 'Recusar',
  'stream.leaveGuest': 'Sair do Live',
  'stream.guests': 'convidados',
  'stream.you': 'Tu',
  'stream.liveChat': 'Chat ao vivo',
  'stream.chatPlaceholder': 'Escreve uma mensagem...',
  'stream.sendTip': 'Enviar gorjeta',
  'stream.tipSent': 'Gorjeta enviada!',
  'stream.tipped': 'deu gorjeta de',
  'stream.inviteCohost': 'Convidar co-anfitriao',
  'stream.cohostInvited': 'Co-anfitriao convidado!',
  'stream.searchUser': 'Procurar utilizador...',
  'stream.noStreams': 'Nenhuma transmissao ao vivo',
  'stream.beFirst': 'Se o primeiro a ir ao vivo!',
  'stream.notFound': 'Transmissao nao encontrada',
  'stream.hasEnded': 'A transmissao terminou',
  'stream.cameraError': 'Erro ao aceder a camera',
  // Screen Share
  'stream.screenShare': 'Partilha de ecra',
  'stream.screenShareStarted': 'Partilha de ecra iniciada',
  'stream.screenShareError': 'Erro ao partilhar ecra',
  // Story Highlights
  'highlights.title': 'Destaques',
  'highlights.added': 'Adicionado aos destaques!',
  'highlights.removed': 'Removido dos destaques',
  'highlights.story': 'Destaque',
  'highlights.remove': 'Remover',
  // Post Scheduling
  'post.schedule': 'Agendar',
  'post.scheduleFor': 'Agendar para',
  'post.willPublishAt': 'Sera publicado em',
  'post.scheduled': 'Publicacao agendada!',
  'post.scheduleBtn': 'Agendar',
  'post.scheduledLabel': 'Agendado',
  // Post Preview
  'post.previewTitle': 'Pre-visualizacao do post',
  // Highlight Albums
  'albums.new': 'Novo',
  'albums.create': 'Criar album',
  'albums.edit': 'Editar album',
  'albums.save': 'Guardar',
  'albums.delete': 'Eliminar',
  'albums.created': 'Album criado!',
  'albums.updated': 'Album atualizado!',
  'albums.deleted': 'Album eliminado!',
  'albums.empty': 'Nenhuma historia neste album',
  'albums.nameLabel': 'Nome do album',
  'albums.namePlaceholder': 'Ex: Viagens, Momentos...',
  'albums.selectStories': 'Selecionar historias',
  'albums.noHighlights': 'Marque historias como destaque primeiro',
  // Annotations
  'annotations.pen': 'Lapis',
  'annotations.text': 'Texto',
  'annotations.rect': 'Retangulo',
  'annotations.arrow': 'Seta',
  'annotations.eraser': 'Borracha',
  'annotations.clear': 'Limpar tudo',
  'annotations.enterText': 'Escreva o texto:',
  // Explore
  'explore.title': 'Explorar',
  'explore.subtitle': 'Publicacoes de amigos de amigos',
  'explore.all': 'Tudo',
  'explore.photos': 'Fotos',
  'explore.videos': 'Videos',
  'explore.empty': 'Nenhum conteudo de media ainda',
  'explore.emptyFeed': 'Nada para explorar ainda',
  'explore.emptyFeedDesc': 'Adicione mais amigos para descobrir publicacoes de amigos de amigos',
  'explore.loadMore': 'Carregar mais',
  'explore.loading': 'Carregando...',
  // Theme toggle
  'nav.explore': 'Explorar',
  'nav.darkMode': 'Modo escuro',
  'nav.lightMode': 'Modo claro',
  // Music
  'music.selectTrack': 'Selecionar musica',
  'music.search': 'Pesquisar musica...',
  'music.addMusic': 'Adicionar musica',
  'stickers.title': 'Stickers',
  'stickers.placed': 'stickers',
  'stickers.power': 'Poder',
  'stickers.culture': 'Cultura',
  'stickers.nature': 'Natureza',
  'stickers.food': 'Comida',
  'stickers.unity': 'Unidade',
  // Post Analytics
  'post.analytics': 'Estatisticas',
  'post.analyticsTitle': 'Analise do post',
  'post.views': 'Vistas',
  'post.shares': 'Partilhas',
  'post.linkCopied': 'Link copiado!',
  'post.reactions': 'Reacoes',
  // Explore Reels
  'explore.reels': 'Reels',
  'explore.viewAll': 'Ver todos',
  // Voice Messages
  'voice.voiceMessage': 'Mensagem de voz',
  'voice.sendError': 'Erro ao enviar mensagem de voz',
  'voice.micError': 'Erro ao aceder ao microfone',
  "gifts.title": "Enviar presente",
  "gifts.send": "Enviar",
  "gifts.balance": "Saldo",
  "gifts.coins": "moedas PAPO",
  "gifts.payWithCoins": "Moedas",
  "gifts.payWithCrypto": "Carteira cripto",
  "gifts.commissionNote": "Cada presente inclui uma comissão de 0,99% para a PAPO.",
  "gifts.cryptoNote": "1 moeda = 0,01 USD, cobrado da sua carteira.",
  "gifts.sent": "Presente enviado!",
  "gifts.insufficient": "Saldo insuficiente",
  "gifts.sentBy": "{name} enviou {gift}",
  "gifts.earnings": "Presentes recebidos",
  "gifts.earningsDesc": "Converta as moedas dos seus presentes numa gorjeta registada no seu saldo.",
  "gifts.convert": "Converter em gorjeta",
  "gifts.converted": "{n} moedas convertidas em gorjeta",
  "gifts.noEarnings": "Ainda não tem presentes para converter",
  "gifts.djembe": "Djembé",
  "gifts.kente": "Kente",
  "gifts.sankofa": "Sankofa",
  "gifts.baobab": "Embondeiro",
  "gifts.mask": "Máscara",
  "gifts.amazigh": "Yaz Amazigh",
  "gifts.lion": "Leão",
  "gifts.crown": "Coroa",
  "mods.title": "Moderadores",
  "mods.desc": "Escolha até 3 amigos ou pessoas que segue para moderar o chat.",
  "mods.search": "Procurar amigos",
  "mods.add": "Nomear",
  "mods.remove": "Remover",
  "mods.limit": "Máximo 3 moderadores",
  "mods.none": "Sem amigos ou seguidos para mostrar",
  "mods.granted": "{name} nomeou-te moderador do live",
  "mods.deleteMsg": "Apagar mensagem",
  "mods.muteChat": "Silenciar no chat",
  "mods.unmuteChat": "Permitir chat",
  "mods.kick": "Expulsar do live",
  "mods.kickConfirm": "Expulsar {name} deste live?",
  "mods.userKicked": "{name} foi expulso",
  "mods.kicked": "Foste expulso deste live",
  "mods.youAreMuted": "Um moderador silenciou-te no chat",
  "mods.youAreUnmuted": "Já podes voltar a escrever no chat",
  "sched.schedule": "Agendar para mais tarde",
  "sched.create": "Agendar live",
  "sched.created": "Live agendado. Os seus amigos podem ativar um lembrete.",
  "sched.invalidDate": "Escolha uma data futura (máx. 30 dias)",
  "sched.upcoming": "Em breve",
  "sched.remind": "Lembrar-me",
  "sched.reminded": "Vamos avisar-te",
  "sched.remindOn": "Vamos avisar 10 min antes e quando começar",
  "sched.startNow": "Começar agora",
  "sched.cancel": "Cancelar",
  "sched.cancelConfirm": "Cancelar este live agendado?",
  "sched.cancelled": "Live agendado cancelado",
  "admin.commissions": "Comissões",
  "admin.commissionsCoins": "Moedas acumuladas (conta PAPO)",
  "admin.commissionsRate": "Taxa de comissão",
  "stickers.amazigh_dancer": "Dançarina amazigh",
  "stickers.mint_tea": "Chá de hortelã",
  "stickers.gnawa": "Músico gnawa",
  "stickers.afro_pick": "Pente afro",
  "stickers.boombox": "Breakdance",
  "stickers.jazz": "Jazz",
  "stickers.steelpan": "Steelpan",
  "stickers.carnival": "Carnaval",
  "stickers.reggae_lion": "Leão reggae",
  "stickers.capoeira": "Capoeira",
  "stickers.conga": "Conga",
  "stickers.palenquera": "Palenquera",
  "stickers.didgeridoo": "Didgeridoo",
  "stickers.kangaroo": "Canguru dot-art",
  "stickers.group.moor": "África moura e amazigh",
  "stickers.group.afroamerican": "Afro-americano",
  "stickers.group.afrocaribbean": "Afro-caribenho",
  "stickers.group.afrolatin": "Afro-latino",
  "stickers.group.aboriginal": "Aborígene australiano",
  "coins.recharge": "Recarregar",
  "coins.shopTitle": "Recarregar moedas PAPO",
  "coins.shopDesc": "Pague com a sua carteira cripto. 1 moeda = 0,01 USD.",
  "coins.fee": "comissão",
  "coins.commissionNote": "Cada compra inclui uma comissão de 0,99% para a PAPO.",
  "coins.bought": "+{n} moedas adicionadas!",
  "coins.insufficientCrypto": "Saldo {sym} insuficiente na carteira",
  "gifts.topGifters": "Top presenteadores",
  "sched.addCalendar": "Adicionar ao calendário",
  "admin.commissionsDaily": "Comissões por dia",
  "admin.source.live_gift": "Presente no live",
  "admin.source.coin_purchase": "Compra de moedas",
  "stickers.tabEmojis": "Emojis",
  "stickers.tabAfro": "Emojis Afro",
  "stickers.tabDiaspora": "Diáspora",
  "stickers.recent": "Recentes",
  "stickers.popular": "Populares animados",
  "admin.commissionsCrypto": "Comissões em cripto",
  "admin.coinReserve": "Reserva de venda de moedas",
  "coins.walletBalance": "Saldo na carteira",
  "admin.commissionsCount": "Comissões registadas",
  "stickers.kwanzaa": "Kwanzaa",
  "stickers.samba": "Samba de Carnaval",
  "stickers.yennayer": "Yennayer",
  "stickers.juneteenth": "Juneteenth",
  "stickers.elephant": "Elefante",
  "stickers.giraffe": "Girafa",
  "stickers.zebra": "Zebra",
  "stickers.hippo": "Hipopótamo",
  "stickers.jollof": "Arroz jollof",
  "stickers.feijoada": "Feijoada",
  "stickers.ackee": "Ackee e bacalhau",
  "stickers.tagine": "Tajine",
  "stickers.premium": "Packs premium",
  "stickers.unlock": "Desbloquear",
  "stickers.unlocked": "Pack desbloqueado! Saldo: {balance} moedas",
  "stickers.pack.fiestas": "Festas da diáspora",
  "stickers.pack.fauna": "Animais de África",
  "stickers.pack.sabores": "Comida tradicional",
  "badges.rank1": "Top 1 presenteador",
  "badges.rank2": "Top 2 presenteador",
  "badges.rank3": "Top 3 presenteador",
  "badges.inProgress": "em curso",
  "badges.tooltip": "Posição {rank} do mês · {coins} moedas oferecidas",
  "badges.leaderboard": "Top presenteadores do mês",
  "payment.checking": "A confirmar o pagamento…",
  "payment.success": "Pagamento concluído!",
  "payment.cancelled": "Pagamento cancelado",
  "payment.error": "Não foi possível confirmar o pagamento",
  "payment.coinsAdded": "As suas moedas PAPO já estão no saldo",
  "payment.back": "Voltar aos Lives",
  "coins.payCard": "Cartão",
  "coins.total": "Total",
  "admin.source.sticker_pack": "Pack de stickers",
  "admin.source.coin_purchase_card": "Compra de moedas (cartão)",
  "admin.usdCard": "USD (cartão)",
  "admin.commissionsByCurrency": "Comissões por moeda",
  "coins.shopDescCard": "Pague com cartão de forma segura via Stripe. 1 moeda = 0,01 USD.",
  "reset.forgotLink": "Esqueceu a palavra-passe?",
  "reset.forgotTitle": "Recupere a sua conta",
  "reset.forgotSubtitle": "Escreva o seu email e enviaremos um link para escolher uma nova palavra-passe.",
  "reset.sendLink": "Enviar link",
  "reset.sent": "Se o email estiver registado, receberá um link em poucos minutos. Veja também o spam. O link expira em 1 hora.",
  "reset.resetTitle": "Nova palavra-passe",
  "reset.resetSubtitle": "Escolha uma palavra-passe com pelo menos 8 caracteres.",
  "reset.newPassword": "Nova palavra-passe",
  "reset.confirmPassword": "Repita a palavra-passe",
  "reset.save": "Guardar palavra-passe",
  "reset.done": "Palavra-passe atualizada. Já pode iniciar sessão.",
  "reset.invalid": "Este link é inválido ou expirou.",
  "reset.requestNew": "Pedir um novo link",
  "reset.tooShort": "Mínimo 8 caracteres",
  "reset.mismatch": "As palavras-passe não coincidem",
  "reset.adminLink": "Link de redefinição",
  "reset.linkCopied": "Link copiado (válido 1 hora). Envie-o ao utilizador.",
  "auth.tooManyAttempts": "Demasiadas tentativas. Aguarde 15 minutos.",
  "authToggle.login": "Iniciar sessão",
  "authToggle.register": "Registar",
  "authToggle.label": "Acesso ao PAPO",
  "download.title": "Descarrega o PAPO",
  "download.desc": "Instala a app no teu telemóvel: grátis, leve e sem lojas.",
  "download.android": "Descarregar para Android",
  "download.ios": "Descarregar para iPhone",
  "download.installed": "O PAPO já está instalado neste dispositivo.",
  "download.androidTitle": "Instalar no Android",
  "download.iosTitle": "Instalar no iPhone / iPad",
  "download.android1": "Abre esta página no Chrome.",
  "download.android2": "Toca no menu ⋮ (canto superior direito).",
  "download.android3": "Escolhe «Instalar aplicação» ou «Adicionar ao ecrã principal».",
  "download.ios1": "Abre esta página no Safari.",
  "download.ios2": "Toca no botão Partilhar (quadrado com seta para cima).",
  "download.ios3": "Escolhe «Adicionar ao ecrã principal» e toca em «Adicionar».",
  "download.done": "Entendido",
  "videoCall.speaker": "Altifalante",
  "videoCall.mic": "Microfone",
  "videoCall.camera": "Câmara",
  "videoCall.hangup": "Desligar",
  "emojiCat.afro": "África e Angola",
  "emojiCat.afro-unity": "Unidade e Resistência",
  "emojiCat.afro-nature": "Natureza Africana",
  "emojiCat.afro-food": "Sabores de Angola",
  "emojiCat.happy": "Felizes",
  "emojiCat.love": "Amor",
  "emojiCat.gesture": "Gestos",
  "emojiCat.hearts": "Corações",
  "emojiCat.celebration": "Celebração",
  "emojiCat.nature": "Natureza",
  "videoCall.incoming": "Videochamada recebida...",
  "video.processing": "A otimizar o vídeo… (pode demorar um pouco)",
  "video.processingShort": "A otimizar…",
  "video.trimmedStory": "O teu vídeo foi cortado para 2 minutos na história",
  "video.trimmedPost": "O teu vídeo foi cortado para 10 minutos",
  "video.failed": "Não foi possível processar o vídeo",
  "videoCall.switchCamera": "Virar",
  "stories.maxSize": "Máximo 500MB",
  "reactions.title": "Reações",
  "reactions.all": "Todas",
  "reactions.remove": "Remover a minha reação",
  "reactions.you": "Tu",
  "iosPush.installTitle": "Recebe notificações no teu iPhone",
  "iosPush.step1": "Toca no botão Partilhar do Safari",
  "iosPush.step2": "Escolhe «Adicionar ao ecrã principal»",
  "iosPush.step3": "Abre o PAPO pelo ícone e ativa as notificações",
  "iosPush.activateTitle": "Ativa as notificações",
  "iosPush.activateDesc": "Sabe na hora de mensagens, amigos e eventos.",
  "iosPush.activate": "Ativar notificações",
  "iosPush.later": "Mais tarde",
  "groups.backToGroups": "Voltar aos grupos",
  "groups.aboutGroup": "Sobre este grupo",
  "download.safari1": "Toca no botão Partilhar (quadrado com seta ⬆) na barra do Safari, em baixo.",
  "download.safari2": "Desliza para baixo e escolhe «Adicionar ao ecrã principal».",
  "download.safari3": "Toca em «Adicionar»: o ícone do PAPO aparece no teu ecrã principal.",
  "download.chrome1": "Toca no botão Partilhar (quadrado com seta ⬆) em cima à direita, junto ao endereço.",
  "download.chrome2": "Escolhe «Adicionar ao ecrã principal» (se não aparecer, desliza a lista).",
  "download.chrome3": "Toca em «Adicionar»: o ícone do PAPO aparece no teu ecrã principal.",
  "download.firefox1": "Toca no menu ☰ em baixo à direita.",
  "download.firefox2": "Escolhe «Partilhar» e depois «Adicionar ao ecrã principal».",
  "download.firefox3": "Toca em «Adicionar»: o ícone do PAPO aparece no teu ecrã principal.",
  "download.iosNote": "A Apple não permite instalar sites com um só botão: faz-se pelo menu Partilhar.",
  "download.copyLink": "Copiar link",
  "download.linkCopied": "Link copiado",
  "download.arrowHint": "Partilhar está aqui",
  "download.animCopy": "Copiar",
  "download.animAdd": "Adicionar ao ecrã principal",
  "download.animStep1": "1 · Toca em Partilhar",
  "download.animStep2": "2 · «Adicionar ao ecrã principal»",
  "download.animStep3": "3 · O PAPO já está no teu iPhone!",
  "reply.reply": "Responder",
  "reply.replyingTo": "A responder a",
  "reply.cancel": "Cancelar resposta",
  "emailPrivacy.show": "Mostrar o meu email a todos",
  "emailPrivacy.hide": "Ocultar o meu email",
  "emailPrivacy.nowVisible": "O teu email agora é visível para todos",
  "emailPrivacy.nowHidden": "O teu email está oculto",
  "emailPrivacy.publicLabel": "Público",
  "emailPrivacy.hiddenLabel": "Oculto",
  "audience.public": "Público",
  "audience.friends": "Amigos",
  "audience.private": "Só eu",
  "audience.onlyMe": "Só tu",
  "audience.who": "Quem pode ver?",
  "audience.saved": "Privacidade atualizada",
  "privacyPanel.title": "Quem vê os teus dados",
  "privacyPanel.desc": "Resumo do que cada pessoa vê: o público, os teus amigos e só tu.",
  "privacyPanel.data": "Dado",
  "privacyPanel.nameBio": "Nome, foto e bio",
  "privacyPanel.email": "Email",
  "privacyPanel.phone": "Telefone",
  "privacyPanel.birthdate": "Data de nascimento",
  "privacyPanel.notSet": "Ainda não adicionado (Editar perfil)",
  "privacyPanel.emailHint": "O email mostra-se ou oculta-se com o ícone do olho no teu perfil ou com o interruptor abaixo.",
  "profile.phoneLabel": "Telefone",
  "profile.birthdateLabel": "Data de nascimento",
  "profile.personalHint": "Opcionais. Por defeito só tu os vês; escolhe quem os pode ver com o ícone do olho no teu perfil.",
  "embed.play": "Reproduzir vídeo de",
  "embed.openIn": "Abrir no",
};
